import React from "react";
import { IconProps } from "./IconProps";

const NotebookIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.75 14C22.75 14.1989 22.671 14.3897 22.5303 14.5303C22.3897 14.671 22.1989 14.75 22 14.75H14C13.8011 14.75 13.6103 14.671 13.4697 14.5303C13.329 14.3897 13.25 14.1989 13.25 14C13.25 13.8011 13.329 13.6103 13.4697 13.4697C13.6103 13.329 13.8011 13.25 14 13.25H22C22.1989 13.25 22.3897 13.329 22.5303 13.4697C22.671 13.6103 22.75 13.8011 22.75 14ZM22 17.25H14C13.8011 17.25 13.6103 17.329 13.4697 17.4697C13.329 17.6103 13.25 17.8011 13.25 18C13.25 18.1989 13.329 18.3897 13.4697 18.5303C13.6103 18.671 13.8011 18.75 14 18.75H22C22.1989 18.75 22.3897 18.671 22.5303 18.5303C22.671 18.3897 22.75 18.1989 22.75 18C22.75 17.8011 22.671 17.6103 22.5303 17.4697C22.3897 17.329 22.1989 17.25 22 17.25ZM27.75 6V26C27.75 26.4641 27.5656 26.9092 27.2374 27.2374C26.9092 27.5656 26.4641 27.75 26 27.75H6C5.53587 27.75 5.09075 27.5656 4.76256 27.2374C4.43437 26.9092 4.25 26.4641 4.25 26V6C4.25 5.53587 4.43437 5.09075 4.76256 4.76256C5.09075 4.43437 5.53587 4.25 6 4.25H26C26.4641 4.25 26.9092 4.43437 27.2374 4.76256C27.5656 5.09075 27.75 5.53587 27.75 6ZM6 26.25H9.25V5.75H6C5.9337 5.75 5.87011 5.77634 5.82322 5.82322C5.77634 5.87011 5.75 5.9337 5.75 6V26C5.75 26.0663 5.77634 26.1299 5.82322 26.1768C5.87011 26.2237 5.9337 26.25 6 26.25ZM26.25 6C26.25 5.9337 26.2237 5.87011 26.1768 5.82322C26.1299 5.77634 26.0663 5.75 26 5.75H10.75V26.25H26C26.0663 26.25 26.1299 26.2237 26.1768 26.1768C26.2237 26.1299 26.25 26.0663 26.25 26V6Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default NotebookIcon;
